import { useQuery } from "@tanstack/react-query";
import { getMe, type AuthUser } from "@/lib/api";

/** Clé de cache de la session courante — invalidée au login/logout. */
export const AUTH_QUERY_KEY = ["auth", "me"] as const;

interface AuthState {
  user: AuthUser | null;
  loading: boolean;
}

/**
 * État d'authentification, adossé au backend (`GET /api/auth/me`). Remplace le suivi de session
 * Supabase : la session vit dans un cookie HttpOnly côté serveur ; ce hook expose l'utilisateur
 * courant (ou `null` si non connecté). Le login (Login.tsx) et le logout (Layout.tsx) mettent à jour
 * la donnée sous [[AUTH_QUERY_KEY]].
 */
export function useAuth(): AuthState {
  const { data, isLoading } = useQuery({
    queryKey: AUTH_QUERY_KEY,
    queryFn: getMe,
    staleTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
  });

  return { user: data ?? null, loading: isLoading };
}
